export default class VehicleRegistrationSuggestion {
  id?: string
  vehicleRegistrationId?: string
  insuranceId?: string
  /** vorgeschlagene Policennummer */
  insuranceNumber?: string
  matchType?: string
  score?: number
  /** Sicherheitsstufe: A sehr wahrscheinlich, B wahrscheinlich, C eher eindeutig, D unsicher */
  confidence?: string
  confidenceText?: string
  /** Umgebung der vorgeschlagenen Police: vergebene Nachbar-Policen, Region, Zeit */
  neighborhoodText?: string
  statusId?: string
  createDate?: Date
  /** erfasste Nummern der Zulassung */
  versicherungsScheinnummer?: string
  versicherungsBestaetigungsNummer?: string
  kennzeichen?: string
  halterName?: string
  datumVersicherungsBeginn?: Date
  /** Erstellungsdatum der vorgeschlagenen Police */
  insuranceCreateDate?: Date
}

export const matchTypeDescriptions: Record<string, string> = {
  Normalized: "Schreibweise abweichend",
  Typo: "Ein Zeichen falsch",
  PrefixTypo: "Präfix 9445 fehlerhaft",
  Missing: "Eine Stelle fehlt",
  Extra: "Eine Stelle zu viel",
  Suffix: "Nur die letzten Stellen erfasst",
  EvbTypo: "eVB-Nummer: ein Zeichen falsch",
}

export function matchTypeDescription(matchType?: string): string {
  return (matchType && matchTypeDescriptions[matchType]) || matchType || ""
}
